export const CATEGORIES = `${process.env.REACT_APP_CATEGORIES || '53'}`.split(
  ',',
)

export const CATEGORIES_INFO = {}
CATEGORIES.forEach(c => {
  CATEGORIES_INFO[c] = {
    name: `${process.env[`REACT_APP_CATEGORY_NAME_${c}`]}`,
    route: `${process.env[`REACT_APP_CATEGORY_ROUTE_${c}`]}`,
  }
})

export const CATEGORY_DEFAULT = `${process.env.REACT_APP_CATEGORY_DEFAULT ||
  '53'}`
